import { useLocaleStore } from '@/stores/locale-store'
import { useLocalisation } from '@/utils/localisation/useLocalisation'

export const LanguageSwitcher = ({ className }: { className?: string }) => {
  const { setLocale } = useLocalisation()
  const locale = useLocaleStore((state) => state.locale)

  return (
    <div className={`flex space-x-2 ${className}`}>
      <button className={locale === 'de' ? 'underline' : ''} onClick={() => setLocale('de')}>
        DE
      </button>
      <button className={locale === 'en' ? 'underline' : ''} onClick={() => setLocale('en')}>
        EN
      </button>
    </div>
  )
}
